export default "__VITE_ASSET__10c0f5d6__"